import type {
  AdminFeedbackPriority,
  AdminFeedbackStatus,
  AdminFeedbackType,
} from '../../../infrastructure/lib/api';

export const FEEDBACK_STATUSES: AdminFeedbackStatus[] = [
  'OPEN',
  'IN_REVIEW',
  'RESOLVED',
  'REJECTED',
  'CLOSED',
];

export const FEEDBACK_TYPES: AdminFeedbackType[] = [
  'BUG',
  'FEATURE_REQUEST',
  'GENERAL',
  'PAYMENT_ISSUE',
  'PERFORMANCE',
  'UI_UX',
  'OTHER',
];

export const FEEDBACK_PRIORITIES: AdminFeedbackPriority[] = [
  'LOW',
  'MEDIUM',
  'HIGH',
  'CRITICAL',
];

export const STATUS_TONE: Record<AdminFeedbackStatus, string> = {
  OPEN: 'bg-amber-500/15 text-amber-300 border-amber-500/30',
  IN_REVIEW: 'bg-sky-500/15 text-sky-300 border-sky-500/30',
  RESOLVED: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
  REJECTED: 'bg-rose-500/15 text-rose-300 border-rose-500/30',
  CLOSED: 'bg-zinc-500/15 text-zinc-300 border-zinc-500/30',
};

export const PRIORITY_TONE: Record<AdminFeedbackPriority, string> = {
  LOW: 'text-zinc-400',
  MEDIUM: 'text-sky-400',
  HIGH: 'text-amber-400',
  CRITICAL: 'text-rose-400 font-bold',
};
